export const BASE_URL = 'https://www.cariñosashub.com'


